
 <header>
  <div>
    <nav class='p-2 navbar navbar-expand-lg navbar-light bg-white shadow-sm'>
      <div class='container'>
        <a routerLink='/' class='navbar-brand'>
            <img src='assets/img/logo.svg' alt="Logo de Segurnet" class="center" loading="lazy" width="150" height="51"/>
        </a>
        <button class='navbar-toggler' [type]='"button"' data-bs-toggle='collapse' data-bs-target='#navbarResponsive' aria-controls='navbarResponsive' aria-expanded='false' aria-label='Toggle navigation' #ToggleMenuMobile>
          <span [ngClass]='"navbar-toggler-icon"'></span>
        </button>
        <div class='collapse navbar-collapse d-lg-flex justify-content-lg-end' id="navbarResponsive" #navResponsive>
          <ul class='navbar-nav ml-auto font-weight-bold text-uppercase pr-lg-3'>
            <li class='nav-item' routerLink='/' >
              <a class='nav-link txtBold '> Inicio │</a>
            </li>
            <li class='nav-item' routerLink='nosotros' routerLinkActive='nav__li-active'>
              <a class='nav-link'>Conócenos</a>
            </li>
            <li class='nav-item' routerLink='servicios' routerLinkActive='nav__li-active'>
              <a class='nav-link'>Servicios</a>
            </li>
            <li class='nav-item' routerLink='cotiza' routerLinkActive='nav__li-active'>
              <a class='nav-link'>Cotizar póliza</a>
            </li>
            <li class='nav-item' routerLink='contacto' routerLinkActive='nav__li-active'>
              <a class='nav-link'>Contacto </a>
            </li>
          </ul>

          <div class='row ps-lg-4 my-2 my-lg-0 asistencia' (click)='callUS()'>
            <div class='col-lg-3 col-md-1 col-2 border-left'>
              <img src='assets/img/headphone.png' alt="Icono de audifonos" class="center" loading="lazy" width="44" height="50"/>
            </div>
            <div class='col-9 p-0 asistencia__text'>
              <p class='txtGris mb-0'><small>¿Necesitas asistencia?</small></p>
              <p class='asistencia__number'>
                <small>809-620-2524</small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</header>

<router-outlet (activate)="onActivate($event)"></router-outlet>


<footer>

 <div class="container-fluid subFooter p-0 ">
  <div class="container">
    <!-- Menu del footer -->
    <nav [ngClass]='"navbar navbar-expand-lg navbar-dark"'>
      <div [ngClass]='"container-fluid p-lg-0"'>
          <ul [ngClass]='"navbar-nav d-flex flex-row"'>
            <li [ngClass]='"nav-item footerNav__li"'>
              <a [routerLink]='""' [ngClass]='"nav-link text-uppercase"'>Inicio</a></li>
            <li class="nav-item footerNav__li"><a routerLink='nosotros' [ngClass]='"nav-link text-uppercase"'>Conócenos</a></li>
            <li class="nav-item footerNav__li"><a  routerLink='servicios' [ngClass]='"nav-link text-uppercase"'>Servicios</a></li>
            <li class="nav-item footerNav__li"><a routerLink='cotiza' [ngClass]='"nav-link text-uppercase"'>Cotizar póliza</a></li>
            <li class="nav-item footerNav__li"><a routerLink='contacto' [ngClass]='"nav-link text-uppercase"'>Contacto</a></li>
          </ul>
      </div>
    </nav>

    <!-- Cuerpo del footer -->
    <div [ngClass]='"row mx-4"'>
      <!-- Direccion -->
      <div [ngClass]='"col-lg-4 mb-lg-5 mb-2 col-12 d-flex justify-content-center  justify-content-lg-start"'>
          <div [ngClass]='"text-center text-lg-left"'>
           <p class="my-2"><span (click)='verMap()'>Dirección: Calle Viriato Fiallo #24, Ensanche Julieta, Distrito Nacional. Santo Domingo, República Dominicana </span></p>
           <p>Teléfono: <a [href]='callUs' [ngClass]='"txtBold noLink"'>809-620-2524</a>
           </p>
         </div>
      </div>

      <!-- Logo -->
      <div [ngClass]='"col-lg-5 mb-lg-1 mb-4 col-12 p-0 d-flex justify-content-center"'>
         <div> <img src='assets/img/SegurnetBlanco.png' alt="Logo de Segurnet" loading="lazy" width="199" height="72"/> </div>
      </div>

   <!-- Redes  y copyright -->
      <div [ngClass]='"col-12 row p-0 col-lg-3 text-lg-right text-center d-flex justify-content-center mx-0 justify-content-lg-end mb-5"'>
         <div class="col-12 justify-content-center d-flex justify-content-lg-start">
           <h4>SEGURNETRD
          <a (click)='fb()'> <img src='assets/img/fb.svg' alt="Logo de Facebook, click aqui para ir a facebook" class="icon" loading="lazy" width="25" height="25"/></a>
          <a (click)='ig()'>&nbsp;
            <img src='assets/img/ig.svg' alt="Logo de Instagram, click aqui para ir a Instagram" class="icon" loading="lazy" width="25" height="25"/></a></h4>
         </div>
         <div class="col-12 d-flex justify-content-center justify-content-lg-start">
           <!-- Sello Certificación UAF -->
          <p>
            <span id="CertificacionUAF">
              <a href="https://certificaciones.uaf.gob.do/certificaciones_so_view.php?editid1=218" target="_blank" rel="nofollow" hreflang="es" title="Cerficación Sujeto Obligado - Unidad de Análisis Financiero">
                <img src="https://certificaciones.uaf.gob.do/certificados/UAF002187D39.png" alt="Sello de Certificaci&oacute;n de Sujeto Obligado" width="83" height="100" lang="es" loading="lazy" />
              </a>
            </span>
          </p>
          <!-- FIN CÓDIGO Certificación -->
         </div>
      </div>
    </div>
  </div>
 </div>

 <!-- Footer terminos y condiciones -->
<div ngClass='container-fluid d-flex justify-content-center  px-0 footer__termCondi'>
    <div class="container row">
      <div class="col-8">
        <nav [ngClass]='"navbar navbar-expand-lg navbar-dark"'>
          <ul [ngClass]='"navbar-nav"'>
            <li [ngClass]='"nav-item"'><a routerLink='terminos-y-condiciones' [ngClass]='"nav-link"'>Términos y condiciones</a></li>
            <li [ngClass]='"nav-item"'><a routerLink='politica-de-privacidad-y-uso' [ngClass]='"nav-link"'>Política de privacidad y uso de datos personales</a></li>
          </ul>
        </nav>
      </div>

      <div class="col-4 mt-3 d-flex justify-content-end">
        <p class="mb-0">&copy; {{ currentYear }} Segurnet - Seguros &amp; Reaseguros</p>
      </div>
    </div>
  </div>
</footer>
